import {I_ACCESS_TOKEN_PARAMS,I_COMMON_DELETE_PARAMS,_customFetch, getFetchDELETEOptions, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- TASK TYPES
// ---------------------------------

const ENDPOINT_TASK_TYPES = '/task_types';

const logger = LoggerService.getInstance();

/**
 * Requete le endpoint task-types GET
 * Récupère la liste des types de tache
 * @param param0
 */
const get = async ({accessToken}:I_ACCESS_TOKEN_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - task_types - get...'));
  const options = getFetchGETOptions({accessToken});
  const URL = ENDPOINT_TASK_TYPES + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,options);
};

interface I_TASK_TYPE_POST_PARAMS {
  accessToken: string,
  name: string,
  description: string,
}
/**
 * Requete le endpoint task-types POST
 * Crée un types de tache
 * @param param0
 * @returns
 */
const post = async ({accessToken,name,description}:I_TASK_TYPE_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - task_types - post...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description.trim()),
    })
  };
  const URL = ENDPOINT_TASK_TYPES + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint task-types DELETE
 * Supprime un types de tache
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - task_types - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_TASK_TYPES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

interface I_TASK_TYPE_PUT_PARAMS {
  accessToken: string,
  id: number,
  name: string,
  description: string,
}
/**
 * Requete le endpoint task-types PUT
 * Modifie un types de tache
 * @param param0
 * @returns
 */
const put = async ({accessToken,id,name,description}:I_TASK_TYPE_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - task_types - put...'));
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description.trim()),
    })
  };
  const URL = `${ENDPOINT_TASK_TYPES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};


const taskTypesEndpoints = {
  get,
  post,
  remove,
  put,
};

export default taskTypesEndpoints;
